<div class="error-section server-error" *ngIf="state && state == '500'">
  <h5 class="error-title">500 - Server Error</h5>
  <p class="error-message">Due to high volume of traffic on our website, we are currently facing some difficulties. Please try again later.</p>
  <p class="redirection-message">We apologize for the inconvenience caused. For any queries feel free to contact
    <a href="mailto:help@zestmoney.in">help@zestmoney.in</a> or chat with our support team.</p>
</div>
<div class="error-section not-found-error" *ngIf="!state || state == '404' || (state && state != '500')">
  <h5 class="error-title">404 - Page not Found</h5>
  <p class="error-message" *ngIf="showCustomErrorMessage" [textContent]="customErrorMessage"></p>
  <p class="error-message" *ngIf="!showCustomErrorMessage">Looks like the page you are looking for does not exist. Please check the URL or visit our Home page.</p>
</div>
<button class="btn zest-btn home-button" [disabled]="toHome" (click)="goToHome()">Home</button>